const config = {
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',
  isTest: process.env.NODE_ENV === 'test',
  apiAuthUrl: process.env.REACT_APP_API_AUTH_URL || '',
  apiUrl: process.env.REACT_APP_API_URL || '',
  apiUrlWS: process.env.REACT_APP_API_URL_WS || '',
  apiPort: process.env.REACT_APP_API_PORT || '',
  wsApi: process.env.REACT_APP_SOCET_URL || '',
  defaultRedirectUrl: process.env.REACT_APP_DEFAULT_REDIRECT_URL || '',
  reCaptchaKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  sentryDSN: process.env.REACT_APP_SENTRY_DSN || '',

  // 1=disabled; 0=enabled
  recaptchaDisabled: process.env.REACT_APP_RECAPTCHA_DISABLED === '1',

  livekitUrl: process.env.REACT_APP_LIVEKIT_URL || 'ws://127.0.0.1:7880',

  appScheme: process.env.REACT_APP_APP_SCHEME || ''
}

export default config
